import { render, staticRenderFns } from "./client-inquiry.vue?vue&type=template&id=1618dc98&scoped=true&"
import script from "./client-inquiry.vue?vue&type=script&lang=js&"
export * from "./client-inquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1618dc98",
  null
  
)

export default component.exports